// extracted by mini-css-extract-plugin
export var border = "_1q-7";
export var brand = "_1q-s";
export var button = "_1q-k";
export var center = "_1q-9";
export var centered = "_1q-5";
export var closeButton = "_1q-b";
export var disabledWrapper = "_1q-l";
export var error = "_1q-o";
export var extraLarge = "_1q-4";
export var extraSmall = "_1q-1";
export var fill = "_1q-h";
export var footer = "_1q-g";
export var footerAction = "_1q-i";
export var footerButtons = "_1q-j";
export var header = "_1q-6";
export var headerWithClose = "_1q-c";
export var icon = "_1q-n";
export var info = "_1q-r";
export var inline = "_1q-8";
export var large = "_1q-3";
export var main = "_1q-d";
export var modal = "_1q-0";
export var neutral = "_1q-t";
export var noPadding = "_1q-f";
export var none = "_1q-u";
export var scrollable = "_1q-e";
export var small = "_1q-2";
export var success = "_1q-q";
export var tight = "_1q-m";
export var titleIcon = "_1q-a";
export var warn = "_1q-p";